module.exports = __webpack_public_path__ + "img/ia-04-2.af062a73.png";